<script setup>
import { Breadcrumb } from 'primevue';
import { computed, ref, watch } from 'vue';
import { useLayout } from '../components/layouts/composables/layout';
import MainSidebar from '../components/layouts/MainSidebar.vue';
import MainTopbar from '../components/layouts/MainTopbar.vue';
import { useBreadcrumb } from '../composables/useBreadcrumb';

const { layoutConfig, layoutState, isSidebarActive } = useLayout();

const outsideClickListener = ref(null);

watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});

const containerClass = computed(() => {
    return {
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-static': layoutConfig.menuMode === 'static',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.staticMenuMobileActive
    };
});

function bindOutsideClickListener() {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            if (isOutsideClicked(event)) {
                layoutState.overlayMenuActive = false;
                layoutState.staticMenuMobileActive = false;
                layoutState.menuHoverActive = false;
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
}

function unbindOutsideClickListener() {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener.value = null;
    }
}

function isOutsideClicked(event) {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');

    return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
}

const { breadcrumb } = useBreadcrumb();

</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
        <main-topbar></main-topbar>
        <main-sidebar></main-sidebar>
        <div class="layout-main-container">
            <div class="layout-main">
                <Breadcrumb v-if="breadcrumb.items?.length" :home="breadcrumb.home" :model="breadcrumb.items"
                    class="mb-4">
                    <template #item="{ item, props }">
                        <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
                            <a :href="href" v-bind="props.action" @click="navigate" class="breadcrumb-link">
                                <span :class="[item.icon, 'text-color']" />
                                <span>{{ item.label }}</span>
                            </a>
                        </router-link>
                        <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                            <span class="text-text">{{ item.label }}</span>
                        </a>
                    </template>
                </Breadcrumb>
                <router-view></router-view>
            </div>
        </div>
        <div class="layout-mask animate-fadein"></div>
    </div>
    <Toast />
    <ConfirmDialog />
</template>
